import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $types } from './FootPrintApiManager.types'

@Injectable({ providedIn: 'root' })
export class FootPrintApiManager_translate_material_from_footprint_to_publicService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { footprint_materials: $types.Materials.Material[] }): Promise<{ public_materials: $types.FootPrintApiManager.public_material[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.footprint_materials)) {
      missingRequiredInParams.push('\'footprint_materials\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/FootPrintApiManager/functions/translate_material_from_footprint_to_public`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

